import {observable} from "mobx";
import {injectable} from "inversify";

export interface IGigyaGateStore {
	get isShowRegistrationPage(): boolean;
	get redirectUrl(): string;

	setIsShowRegistrationPage: (data: boolean) => void;
	setRedirectUrl: (url: string) => void;
}

@injectable()
export class GigyaGateStore implements IGigyaGateStore {
	@observable private _isShowRegistrationPage: boolean = false;
	@observable private _redirectUrl: string = "";

	get isShowRegistrationPage() {
		return this._isShowRegistrationPage;
	}

	get redirectUrl() {
		return this._redirectUrl;
	}

	setIsShowRegistrationPage = (data: boolean) => {
		this._isShowRegistrationPage = data;
	};

	setRedirectUrl = (url: string) => {
		this._redirectUrl = url;
	};
}
